import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import ReactStars from 'react-rating-stars-component';
import Button from 'react-bootstrap/Button';

const CommonRatingModal = ({ show, onHide, onRatingSubmit }: any) => {
    const [rating, setRating] = useState(0);
    const [remarks, setRemarks] = useState('');

    const handleRatingSubmit = () => {
        // Add any logic you need before submitting the rating
        onRatingSubmit({ rating, remarks });
        // Reset state
        setRating(0);
        setRemarks('');
    };

    const setempty = () => {
        setRating(0);
        setRemarks('');
    }

    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton onClick={() => {
                setempty();
            }}>
                <Modal.Title>Rate Vendor</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ padding: '10px 24px' }}>
                <div className="material_form_cover">
                    <form
                        onSubmit={e => {
                            e.preventDefault();
                            // Add form submission logic here if needed
                        }}
                    >
                        <div className="field_box field_no_margin">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="form-floating">
                                        <p style={{ marginBottom: '0px', fontSize: '14px', fontWeight: '600' }}>
                                            Select Rating
                                        </p>
                                        <ReactStars
                                            count={5}
                                            onChange={newRating => setRating(newRating)}
                                            size={40}
                                            isHalf={true}
                                            emptyIcon={<i className="far fa-star" style={{ color: 'white' }}></i>}
                                            halfIcon={
                                                <i className="fa fa-star-half-alt" style={{ color: 'white' }}></i>
                                            }
                                            fullIcon={<i className="fa fa-star" style={{ color: 'white' }}></i>}
                                            activeColor="#ffd700"
                                        />
                                    </div>

                                    {/* Remarks Input */}

                                    <div className="form-floating">
                                        <input
                                            id="remarks"
                                            className="form-control"
                                            placeholder="Remark"
                                            value={remarks}
                                            onChange={e => setRemarks(e.target.value)}
                                        />
                                        <label htmlFor="floatingInput">Remarks</label>
                                    </div>

                                    {/* Additional form inputs can be added here */}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    className="btn custom_btn border_btn with_icon"
                    onClick={() => {
                        onHide();
                        setempty();
                    }}
                >
                    Cancel
                </button>
                <button className="btn dark_btn custom_btn" onClick={handleRatingSubmit}>
                    Save
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default CommonRatingModal;
